import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["type", "optionsSection", "conditionQuestion", "conditionValueSection"]

  connect() {
    this.toggleOptions()
    this.toggleConditionValue()
  }

  toggleOptions() {
    const choiceTypes = ["single_choice", "multiple_choice", "select"]
    this.optionsSectionTarget.style.display = choiceTypes.includes(this.typeTarget.value) ? "block" : "none"
  }

  updateConditionOptions() {
    this.toggleConditionValue()
  }

  toggleConditionValue() {
    this.conditionValueSectionTarget.style.display = this.conditionQuestionTarget.value ? "block" : "none"
  }
}
